import { call, put, takeLatest } from "redux-saga/effects";
import { authApi } from "../../../api/auth/authApi";
import { IChangePassRequest } from "../../../model/request/auth/IChangePassRequest";
import { ILoginRequest } from "../../../model/request/auth/ILoginRequest";
import { ILoginVNPTRequest } from "../../../model/request/auth/ILoginVNPTRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { NotifyHelper } from "../../../helpers/toast";
import {
  eAuthActionTypeIds,
  IAuthActions,
} from "../../action-types/auth/IAuthActions";
import { rootActions } from "../../actions/rootActions";

export function* authSaga(): any {
  yield takeLatest(eAuthActionTypeIds.LOGIN_START, loginWorker);
  yield takeLatest(eAuthActionTypeIds.GET_USER_INFO_START, getDetailWorker);
  yield takeLatest(eAuthActionTypeIds.LOGIN_VNPT_START, loginVNPTWorker);
  yield takeLatest(
    eAuthActionTypeIds.GET_USER_INFO_VNPT_START,
    getDetailVNPTWorker,
  );
  yield takeLatest(eAuthActionTypeIds.CHANGE_PASS_START, changePassWorker);
}

function* loginWorker(action: IAuthActions): any {
  const res: IBaseRespone = yield call(
    authApi.logIn,
    action.payload as ILoginRequest,
  );
  if (res.is_success) {
    yield put(rootActions.auth.LOGIN_SUCCESS(res.data));
  } else {
    yield put(rootActions.auth.LOGIN_ERROR(res.message ?? "Có lỗi"));
  }

  yield put(rootActions.auth.GET_USER_INFO_START(undefined));
}

function* getDetailWorker(action: IAuthActions): any {
  const res: IBaseRespone = yield call([authApi, authApi.getUser]);
  if (res.is_success) {
    yield put(rootActions.auth.GET_USER_INFO_SUCCESS(res.data));
  } else {
    yield put(rootActions.auth.GET_USER_INFO_ERROR(res.message ?? "Có lỗi"));
  }
}

function* loginVNPTWorker(action: IAuthActions): any {
  const res: IBaseRespone = yield call(
    authApi.logInVNPT,
    action.payload as ILoginVNPTRequest,
  );
  if (res.is_success) {
    yield put(rootActions.auth.LOGIN_VNPT_SUCCESS(res.data));
  } else {
    yield put(rootActions.auth.LOGIN_VNPT_ERROR(res.message ?? "Có lỗi"));
  }

  yield put(rootActions.auth.GET_USER_INFO_VNPT_START(undefined));
}

function* getDetailVNPTWorker(action: IAuthActions): any {
  const res: IBaseRespone = yield call([authApi, authApi.getUserVNPT]);
  if (res.is_success) {
    yield put(rootActions.auth.GET_USER_INFO_VNPT_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.auth.GET_USER_INFO_VNPT_ERROR(res.message ?? "Có lỗi"),
    );
  }
}

function* changePassWorker(action: IAuthActions): any {
  const request = action.payload as IChangePassRequest;
  const res: IBaseRespone = yield call(authApi.changePassword, request);
  if (res.is_success) {
    yield put(rootActions.auth.CHANGE_PASS_SUCCESS(res.data));

    /*
      ĐỔI MẬT KHẨU XONG PHẢI ĐĂNG NHẬP LẠI.
      Cổng đăng nhập THU HỒI token cũ ngay khi mật khẩu đổi, trong khi phiên phía phần mềm vẫn còn
      -> người dùng ở lại màn hình với một token đã chết: gọi API nào cũng hỏng (trước đây
      /account/info nổ NullReferenceException thành lỗi 500, người dùng không hiểu vì sao).
      Nên chủ động: báo một câu rồi xóa phiên, đưa về màn đăng nhập.
    */
    NotifyHelper.Success(
      "Đổi mật khẩu thành công. Vui lòng đăng nhập lại bằng mật khẩu mới.",
    );
    yield call([authApi, authApi.logout]); // xóa phiên phía máy chủ (cookie sid)
    yield put(
      rootActions.auth.LOGOUT_START({ access_token: "", refresh_token: "" }),
    );
  } else {
    yield put(rootActions.auth.CHANGE_PASS_ERROR(res.message ?? "Có lỗi"));
  }
}
